import { useEffect, useState } from 'react';
import {
  prepareBrandStylesForConsumer,
  useClientGoogleFonts
} from '@getbento/website-components-rc1';
import { get } from '@/apis';
import { RESERVATIONS_BRAND_STYLES_ENDPOINT } from '@/apis/constants/endpoints';
import { buildBentoboxApiEndpoint } from '@/apis/helpers';
import { createMuiTheme } from '@/brand';
import { createBrandMuiTheme } from '@/brand/helpers/theme';
import {
  BrandImage,
  BrandResponse,
  BrandStyles,
  PrivateBrandStyles
} from '@/types/brand';
import { customGoogleFonts } from '@/theme/themes/font';

export const useBentoTheme = () => {
  const [hasFeature, setHasFeature] = useState<boolean>(false);
  const [isFetchingThemeData, setIsFetchingThemeData] = useState<boolean>(true);
  const [brand, setBrand] = useState<BrandResponse['brand']>({} as any);
  const [styles, setStyles] = useState<BrandStyles>({ base: {}, styles: [] });
  const [brandImage, setBrandImage] = useState<BrandImage>({
    url: '',
    alt_text: '',
    image_large_url: ''
  });
  const [brandLogo, setBrandLogo] = useState({ logoUrl: '', altText: '' });

  useEffect(() => {
    const endpoint = buildBentoboxApiEndpoint(
      RESERVATIONS_BRAND_STYLES_ENDPOINT
    );

    get<BrandResponse>(endpoint, {
      customConfig: { withCredentials: false }
    }).then(
      /* istanbul ignore next*/ response => {
        const { brand, has_brand_engine_feature_flag, brand_image, logo } =
          response.data;

        setIsFetchingThemeData(false);
        setHasFeature(brand && has_brand_engine_feature_flag);
        setBrand(brand);
        brand_image && setBrandImage(brand_image[0]);
        if (brand?.logos && brand?.logos?.length > 0) {
          const brandLogo = brand.logos[0]

          const logos = {
            logoUrl: brandLogo?.url,
            altText: brandLogo?.alt_text
          };

          setBrandLogo(logos);
        }
      }
    );
  }, []);

  const brandStyles: PrivateBrandStyles = brand.styles;

  useClientGoogleFonts({
    isFeatureEnabled: hasFeature,
    brandFonts: [...customGoogleFonts, ...(brand.fonts || [])]
  });

  useEffect(() => {
    if (!hasFeature || !brandStyles) {
      return;
    }

    setStyles(prepareBrandStylesForConsumer(brandStyles));
  }, [hasFeature, brandStyles]);

  const theme = hasFeature
    ? createBrandMuiTheme(styles, brand.fonts)
    : createMuiTheme();

  return {
    theme,
    brand,
    brandImage,
    brandLogo,
    isFetchingThemeData
  };
};
